import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "store-edit-wrapper" };
const _hoisted_3 = {
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_form = _resolveComponent("v-form");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_form, {
                ref: "formRef",
                onSubmit: _withModifiers(_ctx.handleSubmitForm, ["prevent"])
            }, {
                default: _withCtx(() => [
                    (_ctx.editPage && _ctx.storeDetail)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.editPage), {
                            key: 0,
                            "store-detail": _ctx.storeDetail,
                            "form-rules": _ctx.formRules,
                            onSetFormData: _ctx.formData,
                            onSetOriginData: _ctx.originPartialData
                        }, null, 40 /* PROPS, NEED_HYDRATION */, ["store-detail", "form-rules", "onSetFormData", "onSetOriginData"]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "mr-2",
                            onClick: _ctx.handleClickCancelForm
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "width-xs": true,
                                    "size-l": true
                                }
                            ]
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.save')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    primary: true,
                                    "width-xs": true,
                                    "size-l": true
                                }
                            ]
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onSubmit"])
        ])
    ]));
}
